import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { CustomFilterUI } from './ui';

export class CustomFilter extends PureComponent {
    static displayName = 'CustomFilterContainer';

    static propTypes = {
        onChange: PropTypes.func,
        name: PropTypes.string,
        value: PropTypes.shape({
            type: PropTypes.string,
            operator: PropTypes.string,
            value: PropTypes.any
        })
    };

    static defaultProps = {
        onChange: undefined,
        name: 'eventFilter',
        value: null
    };

    render() {
        const { name, value, onChange } = this.props;
        return <CustomFilterUI value={value} onChange={onChange} name={name} />;
    }
}

export const CustomFilterContainer = compose()(CustomFilter);
